import 'bootstrap/dist/css/bootstrap.min.css';
import React, { lazy, Suspense } from 'react';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import 'react-modern-drawer/dist/index.css';
import 'react-phone-input-2/lib/style.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
// import timeGridPlugin from "@fullcalendar/timegrid";
// import '@fullcalendar/timegrid';
// import '@fullcalendar/timegrid/dist/timegrid.css';

// import '@fullcalendar/core/main.css';
// import '@fullcalendar/daygrid/main.css';
// import '@fullcalendar/timegrid/dist/timegrid.css';

import './Assets/styles/styles.css';

import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
// import ProtectedRoute from './Guards/ProtectedRoute';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
// import 'flag-icon-css/css/flag-icon.min.css';
// Core PrimeReact styles
// import 'react-clock/dist/Clock.css';
import Loader from './Components/UI/Loader';
import BeforeLoginRoute from './Guards/BeforeLoginRoutes';
import ProtectedRoute from './Guards/ProtectedRoute';
import ProtectVerifyOtpRoute from './Guards/ProtectVerifyOtpRoute.js';
import './index.css';
import Appointements from './Pages/Appointements';
import Settings from './Pages/Settings';
import Statistics from './Pages/Statistics/index.js';
import './table.css';
// Lazy Imports
// Before Login Routes
const SignUpPage = lazy(() => import('./Pages/Signup'));
const OtpVerification = lazy(() => import('./Pages/OtpVerification'));
const ResetPinCode = lazy(() => import('./Pages/ResetPinCode'));
const ClinicInformation = lazy(() => import('./Pages/ClinicInformation'));
const SignInPage = lazy(() => import('./Pages/SignIn'));
const TermOfServices = lazy(() => import('./Pages/TermsOfServices/index.js'));
const PrivacyPolicy = lazy(() => import('./Pages/PrivacyPolicy'));
const PatientListPage = lazy(() => import('./Pages/PatientList'));
const FurtherSignupSteps = lazy(() => import('./Pages/SignupFurtherSteps'));
const Dashboard = lazy(() => import('./Pages/Dashboard'));
const ForgotPassword = lazy(() => import('./Pages/ForgotPassword'));

function App() {
  return (
    <>
      <ToastContainer
        position="top-right"
        // autoClose={false}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastClassName="custom-toast-class"
        bodyClassName="custom-toast-body"
        progressClassName="custom-progress-bar"
      />
      {/* <DemoButton /> */}
      {/* <SeparatorButton /> */}
      <BrowserRouter>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<BeforeLoginRoute element={SignInPage} />} />
            <Route path="/sign-up" exact element={<BeforeLoginRoute element={SignUpPage} />} />
            <Route path="/statistics" exact element={<ProtectedRoute element={Statistics} />} />
            <Route
              path="/signup-steps"
              element={<BeforeLoginRoute element={FurtherSignupSteps} />}
            />
            <Route
              path="/otp-verification"
              exact
              element={<ProtectVerifyOtpRoute element={OtpVerification} />}
            />
            <Route
              path="/reset-pincode"
              exact
              element={<BeforeLoginRoute element={ResetPinCode} />}
            />
            <Route
              path="/clinic-info"
              exact
              element={<BeforeLoginRoute element={ClinicInformation} />}
            />
            <Route
              path="/forgot-password"
              exact
              element={<BeforeLoginRoute element={ForgotPassword} />}
            />
            <Route
              path="/patient-list"
              exact
              element={<ProtectedRoute element={PatientListPage} />}
            />
            <Route path="/settings" exact element={<ProtectedRoute element={Settings} />} />
            <Route
              path="/appointments"
              exact
              element={<ProtectedRoute element={Appointements} />}
            />

            <Route path="/terms-of-services" exact element={<TermOfServices />} />
            <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
            <Route path="/dashboard" exact element={<ProtectedRoute element={Dashboard} />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}

export default App;
